module.exports = __webpack_public_path__ + "img/Winner-10.097571e5.jpg";